import { LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS } from "../../../modules/similarItems/constants";
import {
  CLEAR_PERSISTENT_ERRORS,
  INITIALISED
} from "../../../modules/common/constants";
import attemptSetup from "./attemptSetup";

export const initialise = () => async dispatch => {
  const [getUserIdentityPromise, getDataPromise] = attemptSetup(dispatch);
  await getDataPromise;
  dispatch({ type: CLEAR_PERSISTENT_ERRORS });
  dispatch({ type: LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS, payload: false });
  await getUserIdentityPromise;
  dispatch({ type: INITIALISED });
};
